<template>
  <div>
    <!-- Short dispatch -->
    <modal
      :title="$t('StatusChangeModal.title')"
      @close-request="closeModal(); reinitializeModal();"
      closable
      >

      <table-element
        :title="$t('OrderCurrent.modal.selected_orders')"
        :fields="fieldsObj"
        :arrOfElement="arrOfOrder"
        :sortSpacing="1"
        :isShowFilter="true"
        :isShowSelectAll="false"
        class="card mx-2 mt-4"
      >
        <template #header-actions>
          <p class="text-center red-text"><i class="fa fa-exclamation mr-2"></i><i>{{$t('StatusChangeModal.process_tooltip')}}</i></p>
          <p class="mb-0 mt-3 mx-2">{{$t('OrderCurrent.count')}} {{arrOfOrder.length}}</p>
        </template>

        <template #pre-body-content>
          <div class="mx-2 mb-2">
            <label v-if="arrOfOrder.length === 1" for="select_status">{{$t('StatusChangeModal.status_select_label_single')}}<span class="red-text">*</span></label>
            <label v-else for="select_status">{{$t('StatusChangeModal.status_select_label_multiple')}}<span class="red-text">*</span></label>
            <regular-select-status
              ref="selectStatusJS"
              id="select_status"
              key="selectStatus"
              :value="selectedStatus"
              @emitStatusSelect="selectedStatus = $event; feedbackMessage = ''"
              class="border"
              :hiddenStatusMap="['Dispatch']"
            />
          </div>

          <create-note
            class="mb-4 px-2"
            ref="noteCompJS"
            :title="''"
            :label="$t('StatusChangeModal.reason_label')"
            :notesList="[]"
            :showCreateNoteButton="false"
            :showList="false"
            :isAllowCreateNote="true"
            :placeholder="$t('CreateNote.new_reason_title')"
          />
        </template>

        <!-- Desktop -->
        <template #body-content-desktop="content">
          <!-- List of orders -->
          <tr v-for="(order, index) in content.results"
          class="table-element_hover text-center"
          :class="{
          'drop': order.status === 'Drop',
          'cancel': order.status === 'Cancel',
          'waiting': order.status === 'Attente',
          'pick': order.status === 'Pick',
          'transit': order.status === 'Transit',
          'dispatch': order.status === 'Dispatch',
          'reject': order.status === 'Reject',
          'inspection': order.status === 'Inspection',
          'transfered': order.status === 'Transférée'
          }"
          :key="index">
            <td v-if="checkHistory(order.historySync)"> <button class="btn btn-kne-green" :id="'dropDate' + order[index]"><i class="fa fa-solid fa-calendar-check"></i></button> </td>
            <td v-else> <button class="btn btn-kne-red" @click="onChangeDropDate(order)"><i class="fa fa-solid fa-calendar"></i> {{$t('DeliveryLocationModal.drop_date_button')}}</button> </td>
            <td>{{order.orderNumber}}</td>
            <td class="nowrap">
              <span>{{ shortenString(order.transmitterName) || '-'}}
                <hover-tool-tip
                  :text="`<div>${order.transmitterAddress || '-'} ${order.transmitterCity || '-'}
                            <br>${order.transmitterProvince || '-'} ${order.transmitterPostcode || '-'}, ${order.transmitterCountry || '-'}
                          </div>`"
                  :left="true"
                  :top="true"
                  clickable
                />
              </span>
            </td>
            <td class="nowrap">
              <span>{{ shortenString(order.receiverName) || '-'}}
                <hover-tool-tip
                  :text="`<p>${order.receiverAddress || '-'} ${order.receiverCity || '-'}
                            <br>${order.receiverProvince || '-'} ${order.receiverPostcode || '-'}, ${order.receiverCountry || '-'}
                          </p>`"
                  :left="true"
                  :top="true"
                  clickable
                />
              </span>
            </td>
            <td>{{order.status}}</td>
          </tr>
        </template>

        <!-- Mobile -->
        <template #body-content-mobile="content">
          <!-- List of orders -->
          <div v-for="(order, index) in content.results"
          class="card my-3 mx-2"
          :class="order.status"
          :key="index">
            <div>
              <p v-if="checkHistory(order.historySync)"> <button class="btn btn-kne-green w-100" :id="'dropDate' + order[index]"><i class="fa fa-solid fa-calendar-check"></i></button> </p>
              <p v-else> <button class="btn btn-kne-red" @click="onChangeDropDate(order)"><i class="fa fa-solid fa-calendar"></i> {{$t('DeliveryLocationModal.drop_date_button')}}</button> </p>
              <div class="card-header">
                <h4>{{order.orderNumber}}</h4>
              </div>
              <p class="mx-2">{{shortenString(order.transmitterName)}}</p>
              <p class="mx-2">{{shortenString(order.receiverName)}}</p>
              <p class="mx-2">{{order.status}}</p>
            </div>
          </div>
        </template>

        <template #post-body-content>
          <div class="mt-2">
            <p class="red-text mb-0 mx-1 text-right">{{ feedbackMessage }}</p>
            <button class="btn btn-kne-orange float-right m-2" @click="onConfirmStatusChange(selectedStatus)"> {{$t('General.confirm')}} </button>
          </div>
        </template>
      </table-element>

      <loading-render v-if="isLoading" />
    </modal>

    <!-- Distributed History -->
    <distributed-history-modal
      key="distributed"
      ref="distModal"
      :isOpen="isDistributedModal"
      :priceOrderLink="priceOrderLink"
      @updateOrderInSelectedFull="(orderId, historyKey, order) => updateOrderInSelectedFull(orderId, historyKey, order)"
      @closeModal="isDistributedModal = false"
    />
  </div>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import RegularInput from '../../basic-components/regularInput.vue'
import regularDatalistDriver from '../../basic-components/regularDatalistDriver.vue'
import HoverToolTip from '../../basic-components/HoverToolTip.vue'
import DistributedHistoryModal from './DistributedHistory-modal.vue'
import DeliveryLocationModal from './DeliveryLocation-modal.vue'
import TableElement from '../Table-component/Table-Element.vue'
import LoadingRender from '../Other-components/LoadingRender.vue'
import RegularSelectStatus from '../../basic-components/RegularSelectStatus.vue'
import CreateNote from '../Other-components/CreateNote.vue'

import { db } from '../../../../firebase'

export default {
  name: 'StatusChangeModal',
  components: {
    Modal,
    RegularInput,
    regularDatalistDriver,
    HoverToolTip,
    DistributedHistoryModal,
    DeliveryLocationModal,
    TableElement,
    LoadingRender,
    RegularSelectStatus,
    CreateNote
  },

  props: {
    arrOfOrder: {
      type: Array,
      required: true
    },
    isOpen: Boolean,
    priceOrderLink: {
      type: Array,
      required: false
    }
  },

  data () {
    return {
      feedbackMessage: '',
      isDistributedModal: false,
      selectedStatus: '',
      fieldsObj: [
       {
         text: this.$t('OrderCurrent.order'),
         type: 'orderNumber',
         value: ''
       },
       {
         text: this.$t('OrderInfo.modal.pickup.title'),
         type: 'transmitterName',
         value: ''
       },
       {
         text: this.$t('OrderInfo.modal.delivery.title'),
         type: 'receiverName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.status'),
         type: 'status',
         value: ''
       }
      ]
    }
  },

  created () {
    this.isLoading = false
  },

  methods: {
    async onConfirmStatusChange (newStatus) {
      if (!newStatus) {
        this.feedbackMessage = this.$t('StatusChangeModal.select_placeholder')
        return
      }

      if (!this.isNoteValid()) {
        this.feedbackMessage = this.$t('StatusChangeModal.note_error')
        return
      }

      if (!this.isDropDateFilled()) {
        this.feedbackMessage = this.$t('OrderCurrent.modal.short_dispatch.drop_date_error')
        return
      }

      const statusMap = await this.$refs.selectStatusJS.getStatusMap()

      this.arrOfOrder.forEach(async (order) => {
        const firebasePath = db.ref('database').child(`transporter/${this.companyUID}/deliveries/${order.orderNumber}/status`)
        if (newStatus === statusMap.cancel.value) await this.isStatusSpecial(order.orderNumber)
        await this.$refs.noteCompJS.pushFirebase(this.$refs.noteCompJS.setDbPath(order.orderNumber))
        await this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': order.orderNumber, 'action': 'CHANGE_ORDER_STATUS', 'status': newStatus, 'date': Date.now()})
        await this.updateOrderFirebase(firebasePath, newStatus)
      })

      await this.emitSelected()
      await this.reinitializeModal()
    },

    isStatusSpecial (orderId) {
      const cancelReason = this.$refs.noteCompJS.getNoteText()

      db.ref(`database/transporter/${this.companyUID}/deliveries/${orderId}/cancelReason`).set(cancelReason)
      .catch(function (error) {
        console.log(error)
      })
    },

    updateOrderFirebase (firebasePath, selectedStatus) {
      firebasePath.set(selectedStatus)
    },

    /** Updates the order in @arrOfOrder so the button in ShortDispatch gets updated for UX purposes */
    updateOrderInSelectedFull (orderId, historyKey, updatedOrder) {
      this.arrOfOrder.find((originalOrder, index) => {
        if (originalOrder.orderNumber === orderId) {
          this.arrOfOrder[index].historySync[historyKey] = updatedOrder
        }
      })
    },

    /** When @dropDate or @isCancelled doesn't exist in the last history key, allow the user to set the @dropDate or @isCancelled to the last history key */
    onChangeDropDate (order) {
      const distModalRef = this.$refs.distModal

      const keys = distModalRef.getObjectKeys(order.historySync)
      const lastKey = distModalRef.getLastArrayData(keys)

      distModalRef.setOrder(order)
      distModalRef.setOrderId(order.orderNumber)
      distModalRef.setHistoryKey(lastKey)

      this.isDistributedModal = true
    },

    /** Used to set the red (false) or green (true) buttons in Short Dispatch */
    checkHistory (history) {
      const isTruthy = this.$refs.distModal.checkHistory(history)
      return isTruthy
    },

    isNoteValid () {
      const isNoteValid = this.$refs.noteCompJS.isNoteFilled
      return isNoteValid
    },

    isDropDateFilled () {
      let isGucci = true

      this.arrOfOrder.forEach(order => {
        if (!this.checkHistory(order.historySync)) isGucci = false
      })

      return isGucci
    },

    setFeedbackMessage (message) {
      this.feedbackMessage = message
    },

    shortenString (text) {
      if (typeof text === 'undefined') return text
      else {
        let subString = text.substring(0, 40)
        if (text.length > 40) subString += '...'
        return subString
      }
    },

    reinitializeModal () {
      this.selectedStatus = ''
      this.feedbackMessage = ''

      this.closeModal()
    },

    emitSelected () {
      this.$emit('clearSelected')
    },

    closeModal () {
      this.$emit('closeModal')
    }
  },

  computed: {
    companyUID () {
      return this.$store.state.authorization.company
    },

    uid () {
      return this.$store.state.user.uid
    }
  }
}
</script>

<style scoped>
</style>
